import "../../../styles/kjedeweb/chainProductView.scss";

import Icon, { iconColor, iconTypes } from "../../common/components/Icon";
import { SubMenu, SubMenuItem } from "../../common/components/SubMenu.jsx";
import { getInvoiceGroups, getSingleChainProductDetail, updateChainProducts } from "../actions/singleChainSortiment.js";

import Calendar from "../../common/components/Calendar";
import DropDownList from "../../common/components/DropDownList";
import { Localization } from "../../common/util/localization.jsx";
import Modal from "../../common/components/Modal.jsx";
import PropTypes from "prop-types";
import React from "react";
import TextField from "../../common/components/TextField.jsx";
import { connect } from "react-redux";
import { downloadHmsPdf } from "../../kundeweb/util/productUtil.jsx";
import moment from "moment";
import { setDropDown } from "../../common/actions/modal.js";
import { toLocaleFixed } from "../../common/util/localization.jsx";

/**
 * Returnerar kalender komponent
 * 
 * @param {object} props
 * @returns {node}
 */
function CalendarDropdown({ setDropDown, dropDown, localization, date, validDates, previousDates, nextOrderDate, onSelectDate }) {
    /**
     * selects the date and hides the dropdown window
     * 
     * @param {object} date
     * @returns {undefined}
     */
    function onClick(date) {
        setDropDown();
        onSelectDate(date);
    }
    const minDate = moment(new Date());
    const maxDate = moment("2100-01-01");

    return (
        <Calendar localization={localization} dropDown={dropDown} date={date} validDates={validDates} previousDates={previousDates} nextOrderDate={nextOrderDate} onSelectDate={onClick} minDate={minDate} maxDate={maxDate} deliveryDates={[]} newSeasonDistrDates={[]} />
    );
}
CalendarDropdown.propTypes = {
    date: PropTypes.string,
    dropDown: PropTypes.bool,
    localization: Localization.propTypes.isRequired,
    nextOrderDate: PropTypes.string,
    setDropDown: PropTypes.func,
    onSelectDate: PropTypes.func,
    previousDates: PropTypes.arrayOf(PropTypes.string.isRequired),
    validDates: PropTypes.arrayOf(PropTypes.string.isRequired),
};



class SingleChainProductModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.fakeSetState = this.fakeSetState.bind(this);
        this.onClickPrintHms = this.onClickPrintHms.bind(this);
        //this.onDeleteProduct = this.onDeleteProduct.bind(this);
        this.onEditProductStatus = this.onEditProductStatus.bind(this);
        //this.onEditProductCatalogue = this.onEditProductCatalogue.bind(this);
        this.onEditInvoiceGroup = this.onEditInvoiceGroup.bind(this);
        this.onEditNewAdmCharge = this.onEditNewAdmCharge.bind(this);
        this.onSaveChanges = this.onSaveChanges.bind(this);
        this.onSelectAdmDate = this.onSelectAdmDate.bind(this);
        this.shouldComponentRender = this.shouldComponentRender.bind(this);
        this.state = { editProduct: this.props.product };

        this.start = true;
    }

    componentDidMount() {
        if (!this.shouldComponentRender() || this.start) {
            this.start = false;
            (async () => {
                await this.props.getInvoiceGroups();
                await this.props.getSingleChainProductDetail(this.props.product.chainId, this.props.product.productId, this.props.product.imageUrl);
            })();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.shouldComponentRender() && prevProps.productDetail != this.props.productDetail) {
            this.fakeSetState();
        }
    }

    fakeSetState() {
        this.setState({ editProduct: this.props.productDetail });
    }

    handleClickOutside() {
        if (this.props.onCloseModal) {
            this.props.onCloseModal();
        }
    }

    shouldComponentRender = () => this.props.productDetail.productId;

    onEditProductStatus(change) {
        this.setState(prevState => ({
            editProduct: {                   // object that we want to update
                ...prevState.editProduct,    // keep all other key-value pairs
                inCatalogue: change.inCatalogue  // update the value of specific key
            }
        }));
    }

    // onEditProductCatalogue(change) {
    //     this.setState(prevState => ({
    //         editProduct: {                   // object that we want to update
    //             ...prevState.editProduct,    // keep all other key-value pairs
    //             inCatalogue: change.inCatalogue  // update the value of specific key
    //         }
    //     }));
    // }

    onEditInvoiceGroup(change) {

        const ig = this.props.invoiceGroups.find(ig => ig.invoiceCode === change.invoiceGroupId);
        const igName = this.capitalizeFirstLetter(ig.description);

        this.setState(prevState => ({
            editProduct: {                   // object that we want to update
                ...prevState.editProduct,    // keep all other key-value pairs
                invoiceGroupId: change.invoiceGroupId,
                invoiceGroupName: igName
            }
        }));
    }

    onEditNewAdmCharge(change) {
        const testAdmCharge = Number(change.futureAdminCharge);
        if (isNaN(testAdmCharge)) {
            //console.log("Ukjent verdi ", change.futureAdminCharge);
        }
        else {
            this.setState(prevState => ({
                editProduct: {                   // object that we want to update
                    ...prevState.editProduct,    // keep all other key-value pairs
                    futureAdminCharge: testAdmCharge  // update the value of specific key
                }
            }));
        }
    }
    onSelectAdmDate(date) {
        this.setState(prevState => ({
            editProduct: {                   // object that we want to update
                ...prevState.editProduct,    // keep all other key-value pairs
                futureAdminChargeDate: date  // update the value of specific key
            }
        }));
    }

    // onDeleteProduct() {
    //     this.setState(prevState => ({
    //         editProduct: {                   // object that we want to update
    //             ...prevState.editProduct,    // keep all other key-value pairs
    //             inCatalogue: false           // update the value of specific key
    //         }
    //     }));
    // }

    capitalizeFirstLetter(s) {
        s = s.toLowerCase();
        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    validateNewPrice() {
        return true;
    }

    getDropDownDateStyle() {
        return {
            width: "450px",
        };
    }

    onClickPrintHms() {
        this.props.downloadHmsPdf(this.props.token, this.props.product, true);
    }

    onSaveChanges() {
        this.props.updateChainProducts(this.props.chainType, [this.state.editProduct]);
        //this.props.onCloseModal(event);
    }


    render() {
        const {
            invoiceGroups,
            localization,
            onCloseModal,
            productDetail,
            saveButtonText,
            title,
            width,
            setDropDown,
        } = this.props;

        // Check if data has been loaded, if not just return empty component
        if (!this.shouldComponentRender()) return <div />;

        const statusOptions = [{ value: true, label: "Åpen" }, { value: false, label: "Stengt" }];
        //const catalogueOptions = [{ value: true, label: "I varekatalog" }, { value: false, label: "Ikke i varekatalog" }];
        const invoiceGroupOptions = invoiceGroups.map(ig => { return { value: ig.invoiceCode, label: this.capitalizeFirstLetter(ig.description) }; });

        let iconType = iconTypes.x;
        if (productDetail.productStorageType == "Tørr") {
            iconType = iconTypes.box;
        } else if (productDetail.productStorageType == "Frys") {
            iconType = iconTypes.snowflake;
        } else if (productDetail.productStorageType == "Kjøl") {
            iconType = iconTypes.fridge;
        }

        const futureAdmDate = !this.state.editProduct.futureAdminChargeDate ? productDetail.futureAdminChargeDate : this.state.editProduct.futureAdminChargeDate;
        const futureAdmDateForDropDown = !futureAdmDate ? moment() : moment(futureAdmDate);
        const futureAdmDateForDisplay = !futureAdmDate ? "Sett dato" : moment(futureAdmDate).format("DD.MM.YYYY");
        const futureAdmReadOnlyChains = !futureAdmDate ? "" : `${toLocaleFixed(productDetail.currentNetPricePerSalesUnit, 2)} (fra ${futureAdmDateForDisplay})`;

        const futureInprice = `${toLocaleFixed(productDetail.futureInPrice, 2)}`;
        const futureInpriceDate = `${productDetail.futureInPriceDate && moment(productDetail.futureInPriceDate).format("DD.MM.YY")}`;
        const futureInpriceText = productDetail.futureInPrice ? `${futureInprice}  (Gjelder fra ${futureInpriceDate})` : "";

        const previousDates = [];
        const validDates = [];

        const iconAvailable = this.state.editProduct.inCatalogue ? "circle-green" : "circle-red";
        //const iconInCatalogue = this.state.editProduct.inCatalogue ? "cicle-blue" : undefined;

        const canSubmit = (saveButtonText == "Lagre");

        return (
            <Modal onCloseModal={onCloseModal} width={width} onClickOutside={this.handleClickOutside}>
                <div className="chain-product-modal-wrapper">
                    <div className="product-modal-header">
                        <div className="header-content">
                            <div className="header-left">
                                <div className="header-detail">{title}</div>
                                <div className="header-name-epd">
                                    <div className="header-prd-name">{this.props.product.productName}</div>
                                    <div className="header-epdNo">EPD {this.props.product.epdNo}</div>
                                </div>
                            </div>
                            <button style={{ marginLeft: "auto" }} className="btn circular" onClick={onCloseModal}>
                                <Icon type={iconTypes.x} color={iconColor.red} />
                            </button>
                        </div>
                    </div>

                    <div className="product-modal-body">
                        <div className="product-modal-rightsidebar">
                            <div className="product-modal-upper">
                                <div className="product-modal-upper-left">
                                    <div className="product-modal-edit-wrapper">
                                        <div className="product-modal-edit-header" style={{ flex: 0.7 }}>Varestatus</div>
                                        <div className="product-modal-edit-header">{/*Varekatalog*/}</div>
                                        { productDetail.webEditInvoiceGroupEndPrice && (
                                            <div className="product-modal-edit-header" style={{ flex: 1.2 }}>Fakturagruppe</div>
                                        )}
                                        <div className="product-modal-edit-header prices" style={{ flex: 0.8 }}>Adm gebyr (%)</div>
                                    </div>
                                    <div className="product-modal-edit-row-wrapper">
                                        <div className="product-modal-edit-row " style={{ flex: 0.7 }}>
                                            <div style={{width:"90%"}}>
                                                <DropDownList disabled={true} strongBorder={false} selectedIconType={iconAvailable} options={statusOptions} onEdit={this.onEditProductStatus} source={this.state.editProduct} property={"inCatalogue"} value={productDetail.inCatalogue} setDropDown={setDropDown}/>
                                            </div>
                                        </div>
                                        <div className="product-modal-edit-row">
                                            <div style={{width:"90%"}}>
                                                {/*<DropDownList strongBorder={false} selectedIconType={iconInCatalogue} options={catalogueOptions} onEdit={this.onEditProductCatalogue} source={this.state.editProduct} property={"inCatalogue"} value={productDetail.inCatalogue} setDropDown={setDropDown}/>*/}
                                            </div>
                                        </div>
                                        { productDetail.webEditInvoiceGroupEndPrice && (
                                            <div className="product-modal-edit-row " style={{ flex: 1.2 }}>
                                                <div style={{width:"90%"}}>
                                                    <DropDownList strongBorder={false} options={invoiceGroupOptions} onEdit={this.onEditInvoiceGroup} source={this.state.editProduct} property={"invoiceGroupId"} value={productDetail.invoiceGroupId} setDropDown={setDropDown}/>
                                                </div>
                                            </div>
                                        )}
                                        <div className="product-modal-edit-row" style={{ flex: 0.8 }}>
                                            <div className="header prices">
                                                {toLocaleFixed(productDetail.currentAdminChargePercent, 2)}
                                            </div>
                                            {productDetail.adminChargeEditable ? (
                                                <React.Fragment>
                                                    <TextField className="input-container product-modal-edit-price" onEdit={this.onEditNewAdmCharge} onChange={this.onEditNewAdmCharge} smallText={true} price={true}
                                                        source={productDetail} property={"futureAdminCharge"} placeholder={localization.text("chain", "newFee")} disabled={false} type="number" validation={this.validateNewPrice} />
                                                    <div className="product-modal-edit-date">
                                                        <SubMenu border={false} style={{ width: "90%", height: "30px", display:"flex" }}>
                                                            <SubMenuItem iconType={iconTypes.calender} style={{width:"100%",paddingTop:"4px",alignItems:"center"}} border={false} children={(<div className="product-modal-edit-date-val noselect">{futureAdmDateForDisplay}</div>)} flex={true} disableDimScreen={true} dropDownStyle={this.getDropDownDateStyle()} expand={true} setDropDown={setDropDown} dropDownChildren={(
                                                                <CalendarDropdown localization={localization} dropDown={true} date={futureAdmDateForDropDown.format("YYYY-MM-DD")} validDates={validDates} previousDates={previousDates} nextOrderDate={""} onSelectDate={this.onSelectAdmDate} setDropDown={setDropDown}/>
                                                            )} />
                                                        </SubMenu>
                                                    </div>
                                                </React.Fragment>
                                            ) : 
                                                <div className="header readOnly">
                                                    { futureAdmReadOnlyChains }
                                                </div>
                                            }
                                        </div>                               
                                    </div>
                                </div>
                                <div className="product-modal-upper-right">
                                    <div className="product-modal-data chain-prices">
                                        <div className="product-modal-data-row chain-prices" >
                                            <div className="product-modal-data-header chain-prices bolder">{"Priser"}</div>
                                            <div className="product-modal-data-info chain-prices bolder">{"Gjeldende"}</div>
                                            <div className="product-modal-data-info chain-prices bolder">{"Fremtidig"}</div>
                                        </div>
                                        <div className="product-modal-data-row chain-prices" >
                                            <div className="product-modal-data-header chain-prices bolder"></div>
                                            <div className="product-modal-data-info chain-prices bolder"></div>
                                            <div className="product-modal-data-info chain-prices-new">{productDetail.futureCustomerBasePriceDate && moment(productDetail.futureCustomerBasePriceDate).format("DD.MM.YY")}</div>
                                        </div>
                                        <div className="product-modal-data-row chain-prices" >
                                            <div className="product-modal-data-header chain-prices">{localization.text("chain", "chainSortiment", "netPrice")}</div>
                                            <div className="product-modal-data-info chain-prices">{toLocaleFixed(productDetail.currentNetPrice, 2)}</div>
                                            <div className="product-modal-data-info chain-prices">{toLocaleFixed(productDetail.futureNetPrice, 2)}</div>
                                        </div>
                                        <div className="product-modal-data-row chain-prices" >
                                            <div className="product-modal-data-header chain-prices">{localization.text("chain", "chainSortiment", "netPricePerUnit")}</div>
                                            <div className="product-modal-data-info chain-prices">{toLocaleFixed(productDetail.currentNetPricePerSalesUnit, 2)}</div>
                                            <div className="product-modal-data-info chain-prices">{toLocaleFixed(productDetail.futureNetPricePerSalesUnit, 2)}</div>
                                        </div>
                                        <div className="product-modal-data-row chain-prices" >
                                            <div className="product-modal-data-header chain-prices">{localization.text("chain", "detail", "basePriceForAdminCharge")}</div>
                                            <div className="product-modal-data-info chain-prices">{toLocaleFixed(productDetail.basePriceForAdminCharge, 2)}</div>
                                            <div className="product-modal-data-info chain-prices">{toLocaleFixed(productDetail.futureBasePriceForAdminCharge, 2)}</div>
                                        </div>
                                        <div className="product-modal-data-row chain-prices" >
                                            <div className="product-modal-data-header chain-prices">{localization.text("chain", "detail", "basePriceWithChargesExclAdminCharge")}</div>
                                            <div className="product-modal-data-info chain-prices">{toLocaleFixed(productDetail.customerBasePriceWithChargesExclAdminCharge, 2)}</div>
                                            <div className="product-modal-data-info chain-prices">{toLocaleFixed(productDetail.futureCustomerBasePriceWithChargesExclAdminCharge, 2)}</div>
                                        </div>
                                        <div className="product-modal-data-row chain-prices" >
                                            <div className="product-modal-data-header chain-prices">{localization.text("chain", "detail", "currentCusBasePrice")}</div>
                                            <div className="product-modal-data-info chain-prices">{toLocaleFixed(productDetail.currentCustomerBasePrice, 2)}</div>
                                            <div className="product-modal-data-info chain-prices">{toLocaleFixed(productDetail.futureCustomerBasePrice, 2)}</div>
                                        </div>
                                        <div className="product-modal-data-row chain-prices" >
                                            <div className="product-modal-data-header chain-prices">{localization.text("chain", "detail", "campaignPrice")}</div>
                                            <div className="product-modal-data-info chain-prices">
                                                <div className="product-modal-data-info chain-prices campaign bolder">{productDetail.currentCampaignPercent}</div>
                                                <div>{productDetail.currentCampaignPeriod}</div>
                                            </div>
                                            <div  className="product-modal-data-info chain-prices">
                                                <div className="product-modal-data-info chain-prices-new bolder">{productDetail.futureCampaignPercent}</div>
                                                <div>{productDetail.futureCampaignPeriod}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div className="product-modal-body">
                                <div className="product-modal-leftsidebar">
                                    <div className="product-modal-image-bg">
                                        <img src={productDetail.imageUrl} className="product-view-item-image" />
                                    </div>
                                    {/* <div className="product-modal-remove">
                                        <button className="btn chainRemoval" onClick={this.onDeleteProduct} >
                                            <Icon type={iconTypes.trashBin} />{localization.text("chain", "chainSortiment", "removeFromSortiment")}
                                        </button>
                                    </div> */}
                                </div> 
                                <div className="product-modal-rightsidebar">
                                    <div className="product-modal-data">
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "eanNoSalesUnit")}</div>
                                            <div className="product-modal-data-info bolder">{productDetail.eanNoSalesUnit}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "eanNoWarehouseUnit")}</div>
                                            <div className="product-modal-data-info bolder">{productDetail.eanNoWarehouseUnit}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "epProductId")}</div>
                                            <div className="product-modal-data-info">{productDetail.productId}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "supplierName")}</div>
                                            <div className="product-modal-data-info">{productDetail.supplierName}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "supplierProductid")}</div>
                                            <div className="product-modal-data-info">{productDetail.supplierProductId}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "category")}</div>
                                            <div className="product-modal-data-info">{productDetail.category}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "calcGroup")}</div>
                                            <div className="product-modal-data-info">{productDetail.calcGroup}</div>
                                        </div>                                       
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "storageType")}</div>
                                            <div className="product-modal-data-info-icon">
                                                <div > {productDetail.productStorageType} </div>
                                                <Icon style={{ flexGrow: 1 }} type={iconType} />
                                            </div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "status")}</div>
                                            <div className="product-modal-data-info">{productDetail.status}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header bolder">{localization.text("chain", "chainSortiment", "noOfSalesUnits")}</div>
                                            <div className="product-modal-data-info bolder">{productDetail.noOfSalesUnits}</div>
                                        </div>                                       
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "weightSalesUnit")}</div>
                                            <div className="product-modal-data-info">{toLocaleFixed(productDetail.weightSalesUnit, 3)}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "heightSalesUnit")}</div>
                                            <div className="product-modal-data-info">{toLocaleFixed(productDetail.heightSalesUnit, 3)}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "lengthSalesUnit")}</div>
                                            <div className="product-modal-data-info">{toLocaleFixed(productDetail.lengthSalesUnit, 3)}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "widthSalesUnit")}</div>
                                            <div className="product-modal-data-info">{toLocaleFixed(productDetail.widthSalesUnit, 3)}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "noOfUnitsInPackage")}</div>
                                            <div className="product-modal-data-info">{productDetail.noOfUnitsInPackage}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "uniqueForChain")}</div>
                                            <div className="product-modal-data-info">{productDetail.uniqueForChain}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                        </div>
                                        <div className="product-modal-data-row">
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header bolder">{localization.text("chain", "detail", "depositAmountWarehouseAndSalesUnit")}</div>
                                            <div className="product-modal-data-info bolder">{productDetail.depositAmountWarehouseAndSalesUnit}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "currentInPrice")}</div>
                                            <div className="product-modal-data-info">{toLocaleFixed(productDetail.currentInPrice, 2)}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "futureInPrice")}</div>
                                            <div className="product-modal-data-info">{futureInpriceText}</div>
                                        </div>                                        
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "linkProductId")}</div>
                                            <div className="product-modal-data-info">{productDetail.linkProductId}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "replacingProductIds")}</div>
                                            <div className="product-modal-data-info">{productDetail.replacingProductIds}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "durabilityDays")}</div>
                                            <div className="product-modal-data-info">{productDetail.durabilityDays}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "weight")}</div>
                                            <div className="product-modal-data-info">{toLocaleFixed(productDetail.weight, 2)}</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-header">{localization.text("chain", "detail", "useSalesUnit")}</div>
                                            <div className="product-modal-data-info">{productDetail.useSalesUnit ? "Ja" : "Nei" }</div>
                                        </div>
                                        <div className="product-modal-data-row">
                                            <div className="product-modal-data-info">{productDetail.campaignInfo}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="product-modal-footer">
                        <div style={{ flex: 3 }}>
                            <button className="btn" onClick={this.onClickPrintHms}>
                                {localization.text("chain", "hms")}
                            </button>
                        </div>
                        <div className="product-modal-footer-button">
                            <button style={{ flexGrow: 1, marginRight: "15px" }} className="btn" onClick={onCloseModal}>
                                <Icon type={iconTypes.x} color={iconColor.red} /> {localization.text("chain", "undo")}
                            </button>
                            <button style={{ flexGrow: 1 }} className="btn" onClick={this.onSaveChanges} disabled={!canSubmit}>
                                {saveButtonText}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}
SingleChainProductModal.propTypes = {
    chainType: PropTypes.number.isRequired,
    downloadHmsPdf: PropTypes.func.isRequired,
    getInvoiceGroups: PropTypes.func.isRequired,
    getSingleChainProductDetail: PropTypes.func.isRequired,
    invoiceGroups: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    localization: Localization.propTypes.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    product: PropTypes.object.isRequired,
    productDetail: PropTypes.object.isRequired,
    saveButtonText: PropTypes.string,
    title: PropTypes.string,
    token: PropTypes.string.isRequired,
    updateChainProducts: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    setDropDown: PropTypes.func.isRequired,
};

const mapStateToProps = () => {
    return (state) => ({
        chainType: state.authentication.chainType,
        deviceType: state.view.deviceType,
        invoiceGroups: state.singleChainSortiment.invoiceGroups,
        isLoading: state.singleChainSortiment.isLoading,
        productDetail: state.singleChainSortiment.productDetail,
        token: state.authentication.token,
    });
};

const mapDispatchToProps = {
    downloadHmsPdf,
    getInvoiceGroups,
    getSingleChainProductDetail,
    updateChainProducts,
    setDropDown
};

export default connect(mapStateToProps, mapDispatchToProps)(SingleChainProductModal);
